export default __webpack_public_path__ + "static/media/g2022-32.b8989ec6.jpeg";